import React, { Component } from 'react';
import { connect } from 'react-redux';
import {issueComplaint, changeTermOfUseValue} from '../../actions/Complaint';
import PropTypes from 'prop-types';
import IssueComplaintComponent from './IssueComplaintComponent';
import * as captchaActions from '../../actions/Captcha';
import * as pageActions from '../../actions/Page';
import Moment from 'moment';

class IssueComplaint extends Component {
    
    componentDidMount = () => this.props.getCaptchaSiteKey();
    onPreviousWindowButtonClick = () => this.props.changePageToCreateComplaintPosition();
    issueComplaint = () => this.props.issueCompalaint(this.props.complaint);
    validateCaptchaKey = (value) => this.props.validateCaptcha(value);
    onTermOfUseChange = (event) => {
        this.props.changeTermOfUseValue(!!(event.target.checked));
    } 

    render() {
        return(
            <IssueComplaintComponent
                complaint = {this.props.complaint}
                complaintPositions={this.props.complaintPositions}
                componentsToRender={this.props.componentsToRender}
                customer={this.props.customer}
                isIssueComplaintButtonEnable = {!!(this.props.captcha.isCaptchaValid & this.props.complaint.isTermOfUseAccepted)}
                onIssueComplaintButtonClick={this.issueComplaint}
                onCaptchaChange= {this.validateCaptchaKey}
                onPreviousWindowButtonClick={this.onPreviousWindowButtonClick}
                onTermOfUseChange={this.onTermOfUseChange}
                siteKey={this.props.captcha.captchaSiteKey} />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        complaint: state.complaint,
        customer: state.customer,
        complaintPositions: state.complaintPositions.positions,
        captcha: state.captcha,
        componentsToRender: state.complaintPositionsComponents.complaintPositionComponents,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changePageToCreateComplaintPosition : () => dispatch(pageActions.changePageToCreateComplaintPosition()),
        issueCompalaint: (complaint) => dispatch(issueComplaint(complaint)),
        getCaptchaSiteKey: () => dispatch(captchaActions.getCaptchaSiteKey()),
        validateCaptcha: (captchaResponse) => dispatch(captchaActions.validateCaptcha(captchaResponse)),
        changeTermOfUseValue : (value) => dispatch(changeTermOfUseValue(value))
    };
};


IssueComplaint.propTypes = {
    issueCompalaint: PropTypes.func,
    complaintPositions: PropTypes.array,
    customer: PropTypes.shape({
        name: PropTypes.string,
        email: PropTypes.string,
        phone: PropTypes.string,
        buildingNumber: PropTypes.string,
        city: PropTypes.string,
        country: PropTypes.string,
        flatNumber: PropTypes.string,
        postalCode: PropTypes.string,
        street: PropTypes.string
    }),
    complaint: PropTypes.shape({
        complaintType: PropTypes.shape({
            displayName: PropTypes.string,
            value: PropTypes.string
        }),
        number: PropTypes.string,
        password: PropTypes.string,
        createDate: PropTypes.instanceOf(Moment)
    }),
    getCaptchaSiteKey: PropTypes.func,
    validateCaptcha: PropTypes.func,
    captcha: PropTypes.shape({
        captchaSiteKey: PropTypes.string,
        isCaptchaValid: PropTypes.bool
    }),
    componentsToRender: PropTypes.array
};

export default connect(mapStateToProps, mapDispatchToProps)(IssueComplaint);


// WEBPACK FOOTER //
// ./src/components/IssueComplaint/IssueComplaint.js